import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

/**
 * Rendu d'un suffixe d'unité avec support KaTeX inline.
 * Si le suffixe contient $$...$$, les parties KaTeX sont rendues via InlineMath.
 * Sinon c'est du texte simple.
 *
 * @param {string} suffixe - Le suffixe brut (ex: "°C", "cm$$^2$$", "$$\frac{km}{h}$$")
 * @param {string} className - Classes CSS additionnelles
 */
const SuffixeRenderer = ({ suffixe, className = '' }) => {
    if (!suffixe) return null;

    if (suffixe.includes('$$')) {
        return (
            <span className={className}>
                {suffixe.split(/(\$\$[^$]+\$\$)/).map((part, i) => {
                    const match = part.match(/^\$\$(.+)\$\$$/);
                    if (match) {
                        try { return <InlineMath key={i} math={match[1]} />; }
                        catch { return <span key={i}>{part}</span>; }
                    }
                    return part ? <span key={i}>{part}</span> : null;
                })}
            </span>
        );
    }

    return <span className={className}>{suffixe}</span>;
};

export default SuffixeRenderer;
